import { render, staticRenderFns } from "./UpdateRecords.vue?vue&type=template&id=4a05c950&scoped=true&"
import script from "./UpdateRecords.vue?vue&type=script&lang=js&"
export * from "./UpdateRecords.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRecords.vue?vue&type=style&index=0&id=4a05c950&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a05c950",
  null
  
)

export default component.exports